import {ShippingOptionFragment} from '../../../../gql/graphql';
import {convertToDateTimeByTimezone} from '../../../utils/dateTime.utils';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {AddressModel} from '../Cart/Address.model';
import {PriceModel} from '../Price.model';

export class SelectedShippingOptionModel {
  public title: string;
  public deliveryTime: string;
  public instructions?: string;
  public pickupAddress?: AddressModel;
  public deliveryTimeSlot?: string | null;
  public hasTimeSlots?: boolean;
  public price: PriceModel;

  constructor(shippingOption: ShippingOptionFragment, modelContext: ModelContext) {
    this.title = shippingOption.title!;
    this.deliveryTime = shippingOption.logistics?.deliveryTime ?? '';
    this.instructions = shippingOption.logistics?.instructions ?? undefined;
    this.pickupAddress = shippingOption.logistics?.pickupDetails?.address
      ? AddressModel.fromCheckoutV1(shippingOption.logistics.pickupDetails.address)
      : undefined;
    this.hasTimeSlots = Boolean(shippingOption?.logistics?.deliveryTimeSlot);
    if (this.hasTimeSlots) {
      const dateMillis = +shippingOption.logistics!.deliveryTimeSlot!.from!;
      const dateTime = convertToDateTimeByTimezone(
        dateMillis,
        modelContext.flowAPI.controllerConfig.wixCodeApi.site.timezone
      );
      this.deliveryTimeSlot = dateTime.toLocaleString({
        weekday: 'short',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    this.price = PriceModel.fromCheckoutV1(shippingOption.cost?.price, modelContext);
  }
}
